/** @module Load pictures only when they come near the screen; long grids load as they scroll. */
import { useEffect, useRef, useState } from "react";

/** True once the element has come near the screen; a set of 250 cards loads as it scrolls. */
export function useNearScreen(enabled: boolean) {
  const ref = useRef<HTMLDivElement | null>(null);
  // Without an observer (old browsers, tests) everything loads right away.
  const [near, setNear] = useState(!enabled || typeof IntersectionObserver === "undefined");
  useEffect(() => {
    const element = ref.current;
    if (near || !element) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) setNear(true);
      },
      { rootMargin: "400px" },
    );
    observer.observe(element);
    return () => {
      observer.disconnect();
    };
  }, [near]);
  return { ref, near };
}
